module.exports = function anonymous(it
) {
var out='<div class="alert alert-'+(it.msgType)+' ';if(!it.reportHasParameters){out+=' big-msg ';}out+='"> ';if(it.icon){out+=' <i class="'+(it.icon)+' icon-large"></i> ';}out+=' '+(it.msg)+'</div>';return out;
}